import { render, staticRenderFns } from "./Uuid.vue?vue&type=template&id=25397faf&"
import script from "./Uuid.vue?vue&type=script&lang=js&"
export * from "./Uuid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports